import type { ScanErrorCode } from '@/pages/qr-scanner/scannerModel'

export class CameraRequestError extends Error {
  constructor(readonly code: ScanErrorCode) {
    super(code)
  }
}

export function requestCameraWithTimeout(
  mediaDevices: Pick<MediaDevices, 'getUserMedia'>,
  timeoutMs: number,
): Promise<MediaStream> {
  return new Promise((resolve, reject) => {
    let timedOut = false
    const timeoutId = globalThis.setTimeout(() => {
      timedOut = true
      reject(new CameraRequestError('camera_timeout'))
    }, timeoutMs)

    mediaDevices.getUserMedia({
      video: { facingMode: { ideal: 'environment' } },
      audio: false,
    }).then((stream) => {
      if (timedOut) {
        stream.getTracks().forEach((track) => track.stop())
        return
      }
      globalThis.clearTimeout(timeoutId)
      resolve(stream)
    }, (cause: unknown) => {
      if (timedOut) return
      globalThis.clearTimeout(timeoutId)
      reject(cause)
    })
  })
}
